import classNames from 'classnames';
import { useAppSelector } from '../../../../configuration/setup/hooks.ts';
import { getRentalCompanies, getAccounts } from '../../appSlice.ts';

export const AccountIdWithName = ({ accountId }: { accountId: string }) => {
    const rentalCompanies = useAppSelector(getRentalCompanies);
    const accounts = useAppSelector(getAccounts);

    const isRentalCompany = rentalCompanies.map(it => it.accountId).includes(accountId);
    const account = accounts.find(it => it.id === accountId);

    return (
        <>
            {account ? (
                <table className={'table table-condensed text-color-black'}>
                    <tbody>
                        <tr>
                            <td className={'padding-0 padding-bottom-5'} style={{ borderTop: 0 }}>
                                {accountId}
                            </td>
                        </tr>
                        <tr>
                            <td className={'padding-0 text-color-dark'} style={{ borderTop: 0 }}>
                                <AccountTypeIcon accountType={account.account_type} isRentalCompany={isRentalCompany} />{' '}
                                {account.name}
                            </td>
                        </tr>
                    </tbody>
                </table>
            ) : (
                <div>{accountId}</div>
            )}
        </>
    );
};

interface AccountTypeIconProps {
    accountType: string;
    isRentalCompany: boolean;
}

const glyphFrom = (accountType: string, isRentalCompany: boolean): string | null => {
    if (accountType === 'PARTNER_CARRIER') {
        return 'rioglyph-businessman';
    } else if (isRentalCompany) {
        return 'rioglyph-share-nodes';
    } else {
        return null;
    }
};

const titleFrom = (accountType: string, isRentalCompany: boolean): string | null => {
    if (accountType === 'PARTNER_CARRIER') {
        return 'Partner Carrier';
    } else if (isRentalCompany) {
        return 'Rental Company';
    } else {
        return null;
    }
};

const AccountTypeIcon = (props: AccountTypeIconProps) => {
    const glyph = glyphFrom(props.accountType, props.isRentalCompany);
    const title = titleFrom(props.accountType, props.isRentalCompany);

    if (!glyph || !title) {
        return <></>;
    }

    return <span className={classNames('rioglyph', glyph, 'rioglyph-align-baseline')} title={title} />;
};
